import React from "react";
import config from "../../config/config";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
export default function SkipConfirmation(props) {
  const userInfo = useSelector((state) => state.userInfo);
  const history = useHistory();
  const params = useParams();

  const JSX = (
    <>
      <Header />
      <main className="container">
        <section className="confirmation-container mt-4">
          <div className="row align-items-center justify-content-center">
            <div className="col-sm-12 col-md-6">
              <div className="img-container">
                <img
                  src={config.customerPortal + `/assets/images/packers.png`}
                  className="img-fluid"
                  alt="packers"
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-6">
              <div className="content-container">
                <h1 className="pb-4">Thank you, {userInfo.customerName} </h1>
                <p>
                  Your Relocation inquire ID <b> {params.estimateId} </b> has been received
                  successfully.
                </p>
                <p>
                  Our team is currently reviewing your request, and we will get back to you as soon as possible with the information you need.
                </p>
                <p>Thank you again for contacting us.</p>
                <div className="text-center my-5">
                  <button
                    onClick={() => {
                      history.push("/dashboard");
                    }}
                    className="btn btn-sm px-3"
                  >
                    Visit Dashboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
  return JSX;
}
